// extracted by mini-css-extract-plugin
module.exports = {"noop":"AsyncTypehead_noop__3-qcB","large":"AsyncTypehead_large__2W2Wx","disabled":"AsyncTypehead_disabled__z1Sts"};